import { OrchestratorError } from "../../model/orchestratorError";
import { transformDate } from "../../utils/date-helpers";
import { getPhoneNumberE164 } from "../../utils/general-helpers";
import { fetchGetJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = OrchestratorError;

type FetchResponseType = {
  data?: DtoType[];
  error?: string;
};

export type TransformedDataType = DtoType & {
  id: number;
  phoneNumberX: string;
  dateTimeAddedX: string;
  usernameOrMeetingRoomNameX: string | null;
};

export type ResponseGuiType = {
  data?: TransformedDataType[];
  error?: string;
};

export async function getOrchestratorErrorsData(): Promise<ResponseGuiType> {
  try {
    const url = apiUrls.getOrchestratorErrorsData;
    const response: FetchResponseType = await fetchGetJSON(url);
    if (response.error) {
      return { error: response.error };
    } else if (response.data) {
      const responseX = response.data.map((item, index) => {
        return {
          ...item,
          // LFC: OrchestratorError record does not include an .id property,
          // so browser complains about:
          //   Warning: Each child in a list should have a unique "key" prop.
          //
          // To fix, we insert an .id field.
          id: index,
          phoneNumberX: getPhoneNumberE164(item.phoneNumber),
          dateTimeAddedX: transformDate(item.dateTimeAdded),
          usernameOrMeetingRoomNameX:
            item.username ||
            item.meetingRoomName ||
            item.meetingRoomDlName ||
            "",
          usernameOrMeetingRoomNameXType: item.username
            ? "Username"
            : item.meetingRoomName
              ? "Meeting Room"
              : item.meetingRoomDlName
                ? "DL"
                : "Other",
        };
      });
      return { data: responseX };
    }
    return { error: "invariant violation" };
  } catch (err) {
    console.error("Error getOrchestratorErrorsData:%o", err);
    return { error: (err as Error).message };
  }
}
